import React from 'react';
import PropTypes from 'prop-types';
import { Container, Input, InputGroup, InputGroupAddon } from '@sm/wds-react';
import { ChoiceOptions } from './ChoiceOptions';

export const SurveyChoice = ({
  index,
  readOnlySurvey,
  questionId,
  answersLength,
  answerValue,
  moveAnswer,
  deleteAnswer,
  handleAnswerChange,
}) => (
  <Container data-testid={`SurveyChoice_Container_${index}`} key={`question_${questionId}_${index + 1}`} mb={4}>
    <InputGroup
      className={`sm-new-survey__choice ${index === 0 ? 'sm-new-survey__choice-first' : ''}`}
      stretched
      size="sm"
      disabled={readOnlySurvey}
    >
      <Container className="sm-new-survey__choice-container">
        <Input
          id={`question-${questionId}-answer${index + 1}`}
          className="sm-new-survey__choice-input sm-new-survey__input"
          stretched
          size="sm"
          value={answerValue}
          placeholder="Enter choice"
          label={index === 0 ? 'Choices' : undefined}
          onChange={event => handleAnswerChange(index, event)}
          disabled={readOnlySurvey}
        />
        <InputGroupAddon>
          <ChoiceOptions
            index={index}
            questionAnswersLength={answersLength}
            moveAnswer={moveAnswer}
            deleteAnswer={deleteAnswer}
          />
        </InputGroupAddon>
      </Container>
    </InputGroup>
  </Container>
);

SurveyChoice.propTypes = {
  index: PropTypes.number,
  readOnlySurvey: PropTypes.bool,
  questionId: PropTypes.string,
  answersLength: PropTypes.number,
  answerValue: PropTypes.string,
  moveAnswer: PropTypes.func,
  deleteAnswer: PropTypes.func,
  handleAnswerChange: PropTypes.func,
};

SurveyChoice.defaultProps = {
  index: 0,
  readOnlySurvey: false,
  questionId: 0,
  answersLength: 0,
  answerValue: '',
  moveAnswer: () => {},
  deleteAnswer: () => {},
  handleAnswerChange: () => {},
};

export default SurveyChoice;
